import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
@Component({
  selector: 'eos-multi-select',
  templateUrl: './multi-select.component.html',
  styles: []
})
export class MultiSelectComponent  extends FieldType{
    defaultOptions = {
      templateOptions: { options: [] },
  };
  ngOnInit() {
  }
  get source(): any {
    return this.to.options;
  }
}

